export const users = {
  admin: {
    title: "Usuarios",
  },
  error: {
    loading: "Error al cargar usuarios",
  },
  history: {
    title: "Historial de Usuarios",
    empty: "No se encontró historial de usuarios",
    id: "ID",
    client: "Cliente",
    affiliateId: "ID de afiliado",
    actions: "Acciones",
    subscription: "Suscripción", // More standard than "Assinatura"
  },
};
